import { render, staticRenderFns } from "./FDayaDukungTypeTable.vue?vue&type=template&id=c10f45dc&scoped=true"
import script from "./FDayaDukungTypeTable.vue?vue&type=script&lang=js"
export * from "./FDayaDukungTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10f45dc",
  null
  
)

export default component.exports